import ContactSection from "components/Contact-Section";
import Footer from "components/Footer";
import MainHeadingText from "components/Main-Heading-Text";
import RevealingText from "components/Revealing-Text";
import SpinningText from "components/Spinning-Text";
import UpslidingText from "components/Upsliding-Text";
import { motion } from "framer-motion";
const About = () => {
  const navigationVariants = {
    initial: { y: "100vh" },
    animate: { y: "100vh" },
    exit: {
      y: ["100vh", "0vh", "0vh", "-100vh"],
      transition: { duration: 2, bounce: 0.3 },
    },
  };
  const navigationPageVariants = {
    initial: { x: 0 },
    exit: {
      x: "-100vw",
      transition: { duration: 0.5, bounce: 0, delay: 1 },
    },
  };
  return (
    <>
      <motion.div
        variants={navigationPageVariants}
        initial='initial'
        exit='exit'
        className={` w-screen  min-h-screen pt-[92px] relative z-[3]`}
      >
        <div className='md:container md:mx-auto mt-16 md:mt-48 px-6 md:px-0'>
          <MainHeadingText text='Momin Naveed' about />
          <MainHeadingText text='Awan' direction='right' about />
          <div className='text-center mt-16 md:mt-48 w-[fit-content] mx-auto'>
            <UpslidingText
              text='Download Resume'
              textSize='text-3xl md:text-5xl'
              maxHeight='max-h-9 md:max-h-12'
              color={"text-dark dark:text-light"}
              onClick={(e) => {
                window.open(
                  "https://firebasestorage.googleapis.com/v0/b/momin-portfolio.appspot.com/o/Momin%20Naveed%20(Web%20Developer).pdf?alt=media&token=35dfa247-4fa7-4422-a85a-c04680347bfd",
                  "_blank",
                );
              }}
            />
          </div>
          <div className='flex flex-col md:flex-row mt-24 md:mt-48 items-start gap-8 md:gap-16'>
            <div className='w-full md:basis-3/12'>
              <>
                <SpinningText
                  textSize='text-2xl'
                  text='Skills'
                  color={"text-dark dark:text-light"}
                />
                <RevealingText
                  infinite
                  text={`HTML 5, CSS 3, SASS (SCSS), Bootstrap, Material UI, Ant Design, Javascript, React Js, Redux, Firebase, GraphQL, Hasura, Node Js, Express, Mongoose, Mongo DB, Socket.io
                  `}
                  textOpacity={"opacity-[.75]"}
                  textSize={"text-xl"}
                />
              </>
              <>
                <SpinningText
                  textSize='text-2xl'
                  text='Education'
                  color={"text-dark dark:text-light"}
                />
                <RevealingText
                  infinite
                  text={`UET Taxila
                  2016 - 2020
                  Bachelors in Telecom Engineering`}
                  textOpacity={"opacity-[.75]"}
                  textSize={"text-xl"}
                />
              </>
              <>
                <SpinningText
                  textSize='text-2xl'
                  text='Interests'
                  color={"text-dark dark:text-light"}
                />
                <RevealingText
                  infinite
                  text={`Unique ideas products, Virtual Reality, Augmented Reality, and Data science projects`}
                  textOpacity={"opacity-[.75]"}
                  textSize={"text-xl"}
                />
              </>
            </div>
            <div className='w-full md:basis-9/12'>
              <RevealingText
                text={`I’m a web developer having industry experience creating powerful ,user friendly and visually appealing websites and web apps. I believe in creating products that are viable and user friendly. I have a curious mind to identify problems and find best solutions.`}
              />
              <RevealingText
                text={`I provide development and consultancy for frontend and backend projects ass needed for your project.`}
              />
              <RevealingText
                text={`Architecture design to Devops, you name it everything is in my domain and can be developed according to project needs.`}
              />
              <RevealingText
                text={`Everything is just an email away from you! Let me know about the requirements and we can start working on it. Hope you enjoy going through the portfolio. Thanks!`}
              />
            </div>
          </div>
          <ContactSection />
          <Footer />
        </div>
      </motion.div>
      <motion.div
        variants={navigationVariants}
        initial='initial'
        animate='animate'
        exit='exit'
        className='bg-dark2 w-screen h-screen fixed top-0 left-0 z-[5] navigation-transition-container'
      ></motion.div>
    </>
  );
};

export default About;
